module.exports = __webpack_public_path__ + "img/mobile-afraid.a61a54d3.png";